import { render, staticRenderFns } from "./NewTrainingModule.vue?vue&type=template&id=35a2cc47&scoped=true&"
import script from "./NewTrainingModule.vue?vue&type=script&lang=ts&"
export * from "./NewTrainingModule.vue?vue&type=script&lang=ts&"
import style0 from "./NewTrainingModule.vue?vue&type=style&index=0&id=35a2cc47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a2cc47",
  null
  
)

/* custom blocks */
import block0 from "./NewTrainingModule.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports